import { render, staticRenderFns } from "./LoginPosgold.vue?vue&type=template&id=21f6bbc6&scoped=true&"
import script from "./LoginPosgold.vue?vue&type=script&lang=js&"
export * from "./LoginPosgold.vue?vue&type=script&lang=js&"
import style0 from "./LoginPosgold.vue?vue&type=style&index=0&id=21f6bbc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6bbc6",
  null
  
)

export default component.exports